import React, { CSSProperties } from 'react'
import { Icon } from '@mobi/component-library/Common/V2'
import { IconName } from '@mobi/component-library/Common/V2/Icon/Icon'
import { HeaderStyled, HeaderTitleStyled } from './Header.styles'
import { ButtonWithIcon } from '@mobi/component-library/Common/Buttons'

type Props = {
  title: string
  iconName: IconName
  onIconSelect: (selected: boolean) => void
  isSelected: boolean
  isDisabled?: boolean
  style?: Partial<CSSProperties>
}

export const Header: React.FC<Props> = ({
  title,
  iconName,
  onIconSelect,
  isSelected,
  isDisabled,
  style,
}) => {
  const iconFill = isSelected ? 'white' : 'none'

  const handleButtonClick = () => {
    onIconSelect(!isSelected)
  }

  return (
    <HeaderStyled style={style}>
      <HeaderTitleStyled>
        <span>{title}</span>
        <ButtonWithIcon
          icon={<Icon name={iconName} fill={iconFill} />}
          isDisabled={isDisabled}
          onClick={handleButtonClick}
        ></ButtonWithIcon>
      </HeaderTitleStyled>
    </HeaderStyled>
  )
}
